<app-nav></app-nav>

<div *ngIf="isLoading" class="outer-spinner">
  <div class="loading-spinner"></div>
</div>

<main class="page" *ngIf="!isLoading">

  <section class="head">
    <div class="head-bg" style="background-image: url('assets/messages/hero-bg.jpg')"></div>

    <div class="head-text">
      <h1>Mess<span>ages</span></h1>
      <p>Connect. Communicate. Collaborate. Build Together.</p>
    </div>

    <div class="head-script">More Than Messages,<br />A Movement.</div>
    <div class="head-quote">People<br />Businesses<br /><span>Communities<br />Opportunities</span></div>
  </section>

  <section class="layout" [class.chat-open]="chatDisplay">

    <!-- CONVERSATIONS -->
    <div class="list-card">
      <div class="t-search">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input type="search" placeholder="Search conversations..." [(ngModel)]="searchText" autocomplete="off" />
      </div>

      <div class="tabs">
        <button type="button" [class.active]="tab === 'all'" (click)="tab = 'all'">All ({{ chatUsers.length }})</button>
        <button type="button" [class.active]="tab === 'unread'" (click)="tab = 'unread'">Unread ({{ unreadChats }})</button>
        <button type="button" [class.active]="tab === 'online'" (click)="tab = 'online'">Online ({{ onlineCount }})</button>
      </div>

      <ul class="rows">
        <li *ngFor="let c of filteredUsers" [class.sel]="selectedUserId === c.user.id"
            [class.has-unread]="unreadOf(c) > 0" (click)="openChat(c)">
          <div class="av-wrap">
            <img [src]="photo(c.user)" (error)="$any($event.target).src='assets/images/avatar.png'" class="av" alt="" />
            <span class="dot" [class.online]="presence.isOnline(c.user.id)"></span>
          </div>
          <div class="who">
            <b>{{ c.user.firstname + ' ' + c.user.lastname }}</b>
            <small [class.unread]="unreadOf(c) > 0">{{ preview(c) }}</small>
          </div>
          <div class="rmeta">
            <time>{{ lastTime(c) }}</time>
            <span class="ub" *ngIf="unreadOf(c) > 0">{{ unreadOf(c) > 99 ? '99+' : unreadOf(c) }}</span>
          </div>
          <button type="button" class="vc" title="Video Call"
                  (click)="$event.stopPropagation(); selectedUserId = c.user.id; selectedUser = c.user; call()">
            <i class="fa-solid fa-video"></i>
          </button>
        </li>
      </ul>

      <p class="empty" *ngIf="filteredUsers.length === 0">
        {{ tab === 'unread' ? 'No unread messages.' : 'No conversations found.' }}
      </p>
    </div>

    <!-- CHAT -->
    <div class="chat-card">
      <div class="placeholder" *ngIf="!chatDisplay">
        <i class="fa-regular fa-comments"></i>
        <p>Click a contact to start chatting</p>
      </div>

      <ng-container *ngIf="chatDisplay && selectedUser">
        <div class="c-head">
          <button type="button" class="back" (click)="closeChat()"><i class="fa-solid fa-arrow-left"></i></button>
          <img [src]="photo(selectedUser)" (error)="$any($event.target).src='assets/images/avatar.png'" class="c-av" alt="" />
          <div class="c-id">
            <h3>{{ selectedUser.firstname + ' ' + selectedUser.lastname }}</h3>
            <span class="status">
              <i class="dot" [class.online]="presence.isOnline(selectedUser.id)"></i>
              {{ presence.statusText(selectedUser) }}
            </span>
            <small *ngIf="sub(selectedUser)">{{ sub(selectedUser) }}</small>
          </div>
          <button type="button" class="ic" (click)="call()" title="Video Call"><i class="fa-solid fa-video"></i></button>
        </div>

        <div class="msgs" #msgBox>
          <div *ngIf="loadMessage" class="center-spin"><div class="loading-spinner"></div></div>

          <div *ngFor="let m of chatMessages" class="msg" [class.mine]="isMine(m)">
            <img *ngIf="!isMine(m)" [src]="photo(selectedUser)" class="m-av" alt="" />
            <div class="bubble">
              <div class="txt">{{ m.chat }}</div>
              <div class="time">
                {{ m.created_at | date : 'shortTime' }}
                <i *ngIf="isMine(m)" class="fa-solid tick" [ngClass]="m.read_at ? 'fa-check-double seen' : 'fa-check'"
                   [title]="m.read_at ? 'Seen' : 'Sent'"></i>
              </div>
            </div>
          </div>

          <p class="empty" *ngIf="!loadMessage && chatMessages.length === 0">No messages yet. Send the first message.</p>
        </div>

        <div class="quick">
          <button type="button" *ngFor="let q of quickReplies" (click)="sendMessage(q)">{{ q }}</button>
        </div>

        <div class="composer">
          <input [(ngModel)]="newMessage" (keyup.enter)="sendMessage()" placeholder="Type a message..." autocomplete="off" />
          <button type="button" class="send" (click)="sendMessage()"><i class="fa-solid fa-paper-plane"></i></button>
        </div>
      </ng-container>
    </div>
  </section>
</main>
